import React, { useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

import Card from '../../components/Card';
import CountrySelect from './CountrySelect';
import PhoneNumberInput from './PhoneNumberInput';
import BaseButton from '../../components/BaseButton';
import ContactPicker from './ContactPicker';

import { steps } from '../step/stepSlice';
import { getCountryEmojiByCountryCode } from '../../lib/countries';
import { fetchNetworks } from '../networks/networksSlice';

export default function ReceiverPhoneNumber() {
  const receiver = useSelector((state) => state.receiver);
  const dispatch = useDispatch();

  const [error, setError] = useState();

  const handleNext = async ({ phoneNumber = receiver.phoneNumber }) => {
    if (phoneNumber.length > 6) {
      try {
        const dispatchResult = await dispatch(fetchNetworks());
        await unwrapResult(dispatchResult);

        setError();
      } catch (error) {
        setError(
          'Check if the country and phone are correct number. We may not yet support your country.'
        );
      }
    } else {
      setError('Phone number to short');
    }
  };

  return (
    <Card step={steps.receiverPhoneNumber} title="Send to" CollapsedContent={CollapsedContent}>
      <div className="country-and-phone-number-wrapper">
        <div className="country-and-phone-number">
          <div className="country-select-wrapper">
            <CountrySelect />
          </div>
          <div className="separator" />
          <div className="phone-number-wrapper">
            <PhoneNumberInput onEnter={handleNext} />
          </div>
        </div>

        <ContactPicker handleError={setError} />

        {error && <div className="error">{error}</div>}
        <BaseButton onClick={handleNext} disabled={receiver.phoneNumber.length < 7}>
          Next
        </BaseButton>
      </div>
    </Card>
  );
}

function CollapsedContent() {
  const { fullPhoneNumber, countryCode } = useSelector((state) => state.receiver);
  return (
    <div className="collapsed-content">
      <div className="content country-and-phone-number">
        <span className="emoji">{getCountryEmojiByCountryCode(countryCode)}</span>
        {fullPhoneNumber}
      </div>
    </div>
  );
}
